<template>
  <div class="floor-select container">
    <div class="floor-select__left fl">
      <img class="product-logo fl" :src="evInfo.pic">
      <div class="floor-select__left__right fl">
        <p class="product-name">{{ evInfo.productName }}</p>
        <div class="button-back" @click="back">重新估价 ></div>
      </div>
    </div>
    <div class="floor-select__right fr">
      <selects
        class="selects-content"
        :class="{'is-open': toggleValue}"
        :selects="evInfo.selectParams"
        :show-name="false"></selects>
      <i
        class="el-icon-arrow-down icon pointer"
        v-if="evInfo.selectParams && evInfo.selectParams.length > 4"
        @click="toggleValue = !toggleValue"
        :class="{'is-open': toggleValue}"></i>
    </div>
  </div>
</template>

<script>
import Selects from '@/core/ev-info/selects';
import { mapState } from 'vuex';

export default {
  components: {
    Selects
  },
  data () {
    return {
      toggleValue: false
    };
  },
  computed: {
    ...mapState({
      evInfo: state => state.evaluate.info || {}
    })
  },
  methods: {
    back () {
      this.$router.push({
        name: 'ProductInfo',
        params: {
          productId: this.evInfo.productId
        }
        // query: {
        //   selecteds: this.$route.query.selecteds
        // }
      });
    }
  }
};
</script>

<style lang="postcss" scoped>

@import 'config.css';

.product {
  &-logo {
    width: 90px;
  }
  &-name {
    width: 160px;
    font-size: 18px;
  }
}

.button-back {
  display: block;
  margin-top: 20px;
  color: inherit;
  cursor: pointer;
  background-color: transparent;
  &:hover {
    color: $active-a-color;
  }
}

.floor-select {
  padding: 20px;
  margin-bottom: 20px;
  color: #666;
  background-color: #fff;
  &__left__right {
    margin-top: 20px;
  }
  &__right {
    width: 896px;
  }
  /deep/ .select-item {
    float: left;
    width: 200px;
    height: 30px;
    font-size: 12px;
    line-height: 30px;
    margin: 0 0 13px 24px;
    color: #666;
    text-align: center;
    background: #f4f4f4;
    border-radius: 4px;
  }
}

.selects-content {
  overflow: hidden;
  max-height: 80px;
  transition: all .6s cubic-bezier(0.075, 0.82, 0.165, 1);
  &.is-open {
    max-height: 300px;
  }
}

.pointer {
  display: block;
  margin: 0 auto;
  margin-top: 10px;
  text-align: center;
  &.is-open {
    transform: rotate(180deg);
    transform-origin: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/evInfo/floor-select.vue